import { IsDefined, IsIn, IsNumber, IsOptional, IsString, Length } from 'class-validator';

import { PriceSource } from '../enum/price-source';

export class PriceUpdateRequest {
    @IsDefined()
    @IsString()
    @Length(36, 36)
    public priceTypeUuid: string;

    @IsDefined()
    @IsString()
    @Length(36, 36)
    public nomPositionUuid: string;

    @IsOptional()
    @IsIn([PriceSource.PRICE_BASE_VALUE, PriceSource.PRICE_VALUE, PriceSource.PRICE_TYPE_DISCOUNT, PriceSource.PRICE_DISCOUNT])
    public sourceValue?: PriceSource;

    @IsOptional()
    @IsNumber()
    public priceValue?: number;

    constructor(data?: Partial<PriceUpdateRequest>) {
        this.priceTypeUuid = data?.priceTypeUuid;
        this.nomPositionUuid = data?.nomPositionUuid;
        this.sourceValue = data?.sourceValue;
        this.priceValue = data?.priceValue;
    }
}

